let SelectCustom = {
  templateUrl: './client/components/selectCustomComponent',
  bindings: {

  },
  controller: function ($scope) {
    var ctrl = this;


    this.$onChanges = function () {
    };
  },
  controllerAs: 'selectCtrl'
};

SelectCustom.$inject = ['$scope'];
export default SelectCustom;
  